import { Injectable, Inject, OnInit } from '@angular/core';
import { IAppConfig, APP_CONFIG } from '../../app.config';
import { HttpClient } from '@angular/common/http';
import { NavigationService } from '../../core/service/navigation.service';
import { MessageService } from '../../core/service/message.service';

@Injectable()
export class AutoActionService {
  constructor(
    private _client: HttpClient,
    private _navigation: NavigationService,
    private _messageService: MessageService,
    @Inject(APP_CONFIG) config: IAppConfig
  ) {
    this._endpoint = `${config.apiEndpointV2}/auto-action`;
  }

  private readonly _endpoint: string;

  sendParameterRequest(): void {
    const parameters = this._navigation.getQueryParameters();
    if (parameters && parameters.size > 0) {
      const jsonObject = {};
      parameters.forEach((value, key) => {
        jsonObject[key] = value;
      });
      this._client.post<any>(`${this._endpoint}/`, JSON.stringify(jsonObject)).subscribe(
        value => {
          if (value && value.message && value.message !== '') this._messageService.showSuccess(value.message);
        },
        value => {
          this._messageService.showWarning(value);
        }
      );
    }
  }
}
